import { render, staticRenderFns } from "./index.vue?vue&type=template&id=09a9742b"
import script from "./placeSubscriptions.js?vue&type=script&lang=js&external"
export * from "./placeSubscriptions.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=09a9742b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports